import React, { Component } from 'react'
import PropTypes from 'prop-types'
import settingsConfig from '@/modules/settings/config'
import SelectInput from '@/modules/base/components/inputs/select-input/select-input'
import lang from '@/lang'
import { FormikContext } from 'formik'
import { getMiscellaneousData } from '@/modules/base/helpers/getSettingsData'

import { toast } from '@/modules/base/components/toast/toastConfig'
import request from '@/modules/base/util/request'

class TitleInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      shouldRefresh: false,
    }

    this.titles = []
    this.getTitles = this.getTitles.bind(this)
    this.onTitleChange = this.onTitleChange.bind(this)
    this.onTitleCreated = this.onTitleCreated.bind(this)
    this.getTitleSelectProps = this.getTitleSelectProps.bind(this)
  }

  getTitles(search) {
    return getMiscellaneousData()
      .then((response) => {
        const { body: { data: { titles } } } = response
        this.titles = titles

        const mappedTitles = titles
          .map(titles => ({ name: titles }))

        if (search) {
          return mappedTitles.filter(title => title.name.toLowerCase().includes(search.toLowerCase()))
        }

        return mappedTitles
      })
  }

  getTitleSelectProps() {
    const { isInline, customClass, useFormik } = this.props
    const name = 'title'

    const fieldMeta = useFormik === undefined || useFormik ? this.context?.getFieldMeta(name) : null
    const value = fieldMeta ? fieldMeta.value : this.props.value

    return {
      label: 'Titel',
      name,
      clearable: true,
      allowCreate: true,
      notAsync: false,
      isInline,
      containerClass: customClass,
      customSelectOptions: {
        placeholder: lang.selectInput.createPlaceholder,
        valueKey: 'name',
        labelKey: 'name',
        isClearable: true,
        loadOptions: this.getTitles,
        defaultOptions: true,
      },
      value: value ? { name: value } : '',
      handleChange: this.onTitleChange,
      onOptionCreated: this.onTitleCreated,
      useFormik: false,
    }
  }

  onTitleChange(option) {
    const { onChange } = this.props
    onChange && onChange(option ? option.name : '')
  }

  onTitleCreated(option) {
    const newTitles = this.titles.concat([option])

    request(settingsConfig.contact, {
      auth: true,
      method: 'POST',
      data: { titles: newTitles },
    })
      .then(() => {
        toast.showToast({ message: lang.contactPersonForm.title.optionCreated(option) })
        this.titles = newTitles
        this.onTitleChange({ name: option })
        this.setState({ shouldRefresh: true })
      })
  }

  render() {
    // necessary for refreshing options if a new one was created
    const { shouldRefresh } = this.state
    const { dataQsId } = this.props
    const titleSelectProps = this.getTitleSelectProps()

    return (
      <SelectInput
        customKey={shouldRefresh}
        dataQsId={dataQsId}
        {...titleSelectProps} />
    )
  }
}

TitleInput.contextType = FormikContext

TitleInput.propTypes = {
  value: PropTypes.string,
  isInline: PropTypes.bool,
  customClass: PropTypes.string,
  useFormik: PropTypes.bool,
  dataQsIds: PropTypes.string.isRequired,
}

TitleInput.defaultProps = {
  isInline: false,
}

export default TitleInput
